import { render, staticRenderFns } from "./PhotoPointTestPicture.vue?vue&type=template&id=133707bf&scoped=true&"
import script from "./PhotoPointTestPicture.vue?vue&type=script&lang=js&"
export * from "./PhotoPointTestPicture.vue?vue&type=script&lang=js&"
import style0 from "./PhotoPointTestPicture.vue?vue&type=style&index=0&id=133707bf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "133707bf",
  null
  
)

export default component.exports